require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./eighth-grade-transition-program.json") })
        }
      }, "path---eighth-grade-transition-program");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---eighth-grade-transition-program!./.cache/json/eighth-grade-transition-program.json
// module id = 890
// module chunks = 231608221292675